"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TablePaginator = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var box_1 = require("../box");
var pagination_controls_1 = require("../pagination-controls");
var table_1 = require("../table");
function TablePaginator(props) {
    var _a = props.border, border = _a === void 0 ? 0 : _a, columns = props.columns, data = props.data, hasAllSelected = props.hasAllSelected, initialSort = props.initialSort, initialSortDirection = props.initialSortDirection, _b = props.limit, limit = _b === void 0 ? 10 : _b, loading = props.loading, maxHeight = props.maxHeight, noResults = props.noResults, lastColumnSticky = props.lastColumnSticky, selected = props.selected, setHasAllSelected = props.setHasAllSelected, setSelected = props.setSelected, stickyColumn = props.stickyColumn, stickyColumnWidth = props.stickyColumnWidth, testId = props.testId;
    var pageCount = Math.ceil(data.length / limit);
    var _c = (0, react_1.useState)(0), offset = _c[0], setOffset = _c[1];
    (0, react_1.useEffect)(function () {
        setOffset(0);
    }, [data]);
    var handlePageClick = function (_a) {
        var selectedPage = _a.selected;
        var newOffset = Math.ceil(selectedPage * limit);
        setOffset(newOffset);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(box_1.Box, { border: border },
            react_1.default.createElement(table_1.Table, { columns: columns, data: data, hasAllSelected: hasAllSelected, initialSort: initialSort, initialSortDirection: initialSortDirection, lastColumnSticky: lastColumnSticky, limit: limit, loading: loading, maxHeight: maxHeight, noResults: noResults, offset: offset, selected: selected, setHasAllSelected: setHasAllSelected, setSelected: setSelected, stickyColumn: stickyColumn, stickyColumnWidth: stickyColumnWidth, testId: testId })),
        react_1.default.createElement(pagination_controls_1.PaginationControls, { pageCount: pageCount, onPageChange: handlePageClick })));
}
exports.TablePaginator = TablePaginator;
//# sourceMappingURL=index.js.map